import React from 'react'
import SubPage from '../templates/subpage'
import '../fragments'

class IndexPage extends React.Component {
  render () {
    const filteredNews = this.props.data.news.edges.filter(edge => {
      const node = edge.node
      return node.heading && node.body && node.body.body
    }).splice(0, 3)
      
    return (
      <SubPage data={this.props.data.home} localization={this.props.data.globalLocalization} news={filteredNews}>
      </SubPage>
    )
  }
}

export default IndexPage
export const indexQuery = graphql`
query indexQueryEn {
  globalLocalization: allContentfulLocalizationString(filter: {key: {regex: "/^global/" }}) {
    edges {
      node { 
        key
        text
        node_locale
      }
    }
  }

  news: allContentfulNewsArticle(filter: {node_locale: {eq: "en-US"}}, limit: 30, sort: {order: DESC, fields: [createdAt]}) {
    edges {
      node {
        createdAt(formatString: "MMM D, YYYY")
        heading
        body {
          body
        }
        backgroundColor
        featureImage {
          title
          sizes(maxWidth: 2560) {
            ...GatsbyContentfulSizes_withWebp
          }
        }
      }
    }
  }


  home: contentfulPage(id: {eq: "c5T7roBiI1O2is82EiIkK8o"}) {
    id
    node_locale
    title
    hero {
      id
      heading
      background {
        sizes(maxWidth: 2560) {
          ...GatsbyContentfulSizes_withWebp
        }
        file {
          url
          contentType
        }
      }
      alignSubheroImage
      body {
        body
      }
      ctaButtons {
        id
        title
        url
      }
      submitForm {
        layout
        description {
          description
        }
        actionUrl
        formId
        u
      }
    }
    ...PageFragment
  }
}
`


// WEBPACK FOOTER //
// ./src/pages/index.en.js